document.addEventListener('DOMContentLoaded', function() {
    // Function to add items to cart
    function addItemsToCart() {
        var items = [];
        document.querySelectorAll('.quantity.field').forEach(function(input) {
            var quantity = parseInt(input.value, 10);
            if (quantity > 0) {
                var variantId = input.getAttribute('data-variant-id');
                items.push({
                    id: variantId,
                    quantity: quantity
                });
            }
        });

        if (items.length > 0) {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: items })
            })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                console.log('Items added:', data);
                alert('All items added to cart!');
                updateCartUI(); // Call to update the UI after adding items
            })
            .catch(function(error) {
                console.error('Error:', error);
                alert('There was an error adding the items to the cart.');
            });
        } else {
            alert('Please add at least one product.');
        }
    }

    // Function to dynamically update the cart UI
    function updateCartUI() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                // Update your cart UI elements here
                console.log(cart); // Log the cart object to see available data
                // Example:
                // document.getElementById('cart-item-count').textContent = cart.item_count;
                // document.getElementById('cart-total-price').textContent = cart.total_price;
                // Optionally, you can redirect to the cart page after updating the UI
                window.location.reload(); // Reload the page to update the cart
            })
            .catch(error => console.error('Error fetching cart:', error));
    }

    // Attach the addItemsToCart function to the button click event
    var addToCartButton = document.querySelector('[value="Add to the cart"]');
    if (addToCartButton) {
        addToCartButton.addEventListener('click', addItemsToCart);
    }
});
